import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
// import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, LinearProgress } from "@material-ui/core";
import { Progress, Badge } from 'reactstrap';
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
// import { useHistory } from "react-router-dom";

import AppTable from "../Table/AppTable";
import TablePaginationActions from "../Table/TablePaginationActions";
// import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import AppUtil from "../../../../utilities/AppUtil";
import AppButton from "../../../../components/CustomButtons/AppButton";
import InputSearch from "../../../../components/Input/InputSearch";
import { FILE_STATUS } from "../../../../config/AppConfig";
import AppConfirmDialog from "../../../../components/Dialog/AppConfirmDialog";
import moment from "moment";
import { fetchImportWorkers, getIsUploadWorkerCSV, fetchProgressingWorkerFiles, checkImportWorkerProgress, loadImportWorker, uploadWorkerCSV, downloadWorkerFileLogs } from "store/slices/importWorker";
// import { fetchWorkerListPaging } from "store/slices/worker";
import { downloadTemplate } from "store/slices/importWorker";
import { fetchPaginationImport, getImportWorkerCachedPage, getImportWorkerCachedSize, getImportWorkerCachedSearchKey, setImportWorkerCachedPage, setImportWorkerCachedSize, setImportWorkerCachedSearchKey } from "store/slices/importWorker";
import ImportWorkerRulesModal from "./ImportWorkerRulesModal";

// const useStyles = makeStyles({
//     ...styles,
//     divider: {
//         marginTop: "1rem",
//         marginBottom: "1rem",
//     },
//     w100: {
//         width: '100%'
//     },
//     listContainer: {

//     },
//     list: {
//         listStyle: 'none',
//         padding: 0,
//         margin: 0
//     },
//     listItem: {
//         marginBottom: '20px',
//         padding: '10px',
//         border: '1px solid rgba(0, 0, 0, 0.2)',
//         borderRadius: '5px',
//         boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
//         '&:hover': {
//             backgroundColor: AppColor.mainColor,
//             color: AppColor.white
//         }
//     },
//     listTitle: {
//         fontSize: '16px',
//         color: AppColor.black,
//         fontWeight: '500',
//         padding: 0,
//         margin: 0
//     },
//     progressing: {
//         '&.progress': {
//             backgroundColor: '#ababab'
//         }
//     }
// });

const headCells = [
    {
        id: "fileName",
        numeric: "left",
        disablePadding: false,
        label: "label.fileName",
    },
    {
        id: "createdDate",
        numeric: "left",
        disablePadding: false,
        label: "label.createdDate",
    },
    {
        id: "completionDate",
        numeric: "left",
        disablePadding: false,
        label: "label.completionDate",
    },
    {
        id: "status",
        numeric: "left",
        disablePadding: false,
        label: "label.status",
    },
    {
        id: "actions",
        numeric: "left",
        disablePadding: false,
        label: "label.actions",
    }
];

const TableImportWorker = () => {
    // const classes = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const paginationImport = useSelector(fetchPaginationImport) || {};
    const savedPage = useSelector(getImportWorkerCachedPage);
    const savedSize = useSelector(getImportWorkerCachedSize);
    const savedSearchKey = useSelector(getImportWorkerCachedSearchKey);
    const [queries, setQueries] = useState({
        asc_sort: true,
        page: savedPage,
        size: savedSize,
        search_key: savedSearchKey,
        sort_field: "createdDate",
    });
    const importFileCsvRef = useRef();
    const getList = useSelector(fetchImportWorkers) || [];
    const isUploadWorkerCSV = useSelector(getIsUploadWorkerCSV);
    const progressingFiles = useSelector(fetchProgressingWorkerFiles) || [];
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [showConfirmImportModal, setShowConfirmImportModal] = useState(false);
    const [fileImport, setFileImport] = useState(null);
    const [searchKey, setSearchKey] = useState(savedSearchKey);
    const [isImporting, setIsImporting] = useState(false);
    const [timeCallCheckProgress, setTimeCallCheckProgress] = useState(0);
    const [showRulesModal, setShowRulesModal] = useState(false);
    // const [progressInterval, setProgressInterval] = useState();

    const emptyRows = data.length === 0;

    const handleChangePage = (event, newPage) => {
        dispatch(setImportWorkerCachedPage(newPage + 1));
        _loadData({ ...queries, page: newPage + 1 });
        AppUtil.scrollToTopById("main-panel");
    };

    const checkProgressStatus = () => {
        dispatch(checkImportWorkerProgress());
    };

    const handleChangeRowsPerPage = (event) => {
        const newSize = parseInt(event.target.value);
        dispatch(setImportWorkerCachedSize(newSize));
        dispatch(setImportWorkerCachedPage(1));
        _loadData({
            ...queries,
            page: 1,
            size: newSize,
        });
        AppUtil.scrollToTopById("main-panel");
    };

    const onSearch = (value) => {
        setSearchKey(value);
        dispatch(setImportWorkerCachedSearchKey(value));
        dispatch(setImportWorkerCachedPage(1));
        _loadData({
            ...queries,
            search_key: value,
            page: 1,
        });
    };

    const _loadData = async ({ page, size, search_key, asc_sort } = {}) => {
        const newQueries = {
            ...queries,
        };
        if (page) {
            newQueries.page = page;
        }
        if (size) {
            newQueries.size = size;
        }
        newQueries.search_key = search_key || "";
        newQueries.asc_sort = !(!asc_sort || false);
        setLoading(true);
        dispatch(loadImportWorker(newQueries))
            .then(({ payload }) => {
                setQueries(newQueries);
                setLoading(false);
                if (payload) {
                    setTotalElements(payload.totalElements);
                }
            });
    };

    useEffect(() => {
        _loadData(queries);
    }, []);

    useEffect(() => {
        if (getList) {
            setData(getList);
        }
    }, [getList]);

    useEffect(() => {
        setTotalElements(paginationImport.totalRecords);
    }, [paginationImport]);

    useEffect(() => {
        if (timeCallCheckProgress !== null) {
            if (timeCallCheckProgress === 0) {
                setTimeCallCheckProgress(null);
                checkProgressStatus();
            } else if (timeCallCheckProgress > 0) {
                setTimeout(()=>{
                    setTimeCallCheckProgress(timeCallCheckProgress - 1);
                }, 1000);
                
            }
        }
    }, [timeCallCheckProgress]);

    useEffect(() => {
        if (progressingFiles.length === 0) {
            setIsImporting(false);
            // if (progressInterval) {
            //     clearInterval(progressInterval);
            //     setProgressInterval();
            //     // dispatch(fetchWorkerListPaging({
            //     //   ...PAGINATION,
            //     //   companyId: authInfo.companyId
            //     // }));
            // }
        } else if (progressingFiles.length > 0) {
            setIsImporting(true);
            setTimeCallCheckProgress(10);
            // setTimeout(()=>{
            //     checkProgressStatus();
            // }, 10000);
            // if (!progressInterval) {
            //     const interval = setInterval(checkProgressStatus, 5000);
            //     setProgressInterval(interval);
            // }
        }
      }, [progressingFiles]);

    const handleChangeImportFileCsv = (event) => {
        if (!event.target.files[0] || isImporting) {
            return null;
        }
        setShowConfirmImportModal(true)
        const file = event.target.files[0];
        setFileImport(file)
        event.target.value = '';
    };

    const _onUploadCsvFile = (isOverride) => {
        if (!isUploadWorkerCSV) {
            const request = { fileImport, isOverride };
            dispatch(uploadWorkerCSV(request));
        }
        setShowConfirmImportModal(false);
    };

    const renderProgressImport = (file) => {
        const onProgressFile = progressingFiles.filter(item => item.id === file.name)[0];
        if (onProgressFile) {
            if (onProgressFile.progress >= 1) {
                return (
                    <Progress animated color='warning' value={parseInt(onProgressFile.progress, 10)}
                        max='100'>{parseInt(onProgressFile.progress, 10)}%</Progress>
                );
            } else {
                return t("label.uploading");
                
            }
        }
    };

    const renderStatus = (row) => {
        // if (row && row.uploading) {
        //     return t("label.uploading");
        // }
        switch (row.processStatus) {
            case FILE_STATUS.DONE:
                return (
                    <div>
                        <Badge color='success'>{t("label.done")}</Badge >
                        {
                            row.errorNumber && row.errorNumber > 0
                                ? <Badge color='danger'>{row.errorNumber}</Badge>
                                : null
                        }
                    </div>
                );
            case FILE_STATUS.ON_PROCESS:
                return renderProgressImport(row);
            default:
                break;
        }
    };

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item>
                    <AppButton
                        label={t('button.uploadCSV')}
                        onClick={() => {
                            if (importFileCsvRef && importFileCsvRef.current) {
                                importFileCsvRef.current.click();
                            }
                        }}
                        disabled={isImporting || showConfirmImportModal}
                    />
                </Grid>
                <Grid item>
                    <AppButton
                        label={t('button.downloadTemplate')}
                        onClick={() => {dispatch(downloadTemplate())}}
                    />
                    <input type="file" hidden name="fileCsv" accept='.csv' ref={importFileCsvRef} onChange={handleChangeImportFileCsv}/>
                </Grid>
                <Grid item>
                    <AppButton
                        label={t('button.importRules')}
                        onClick={() => setShowRulesModal(true)}
                        mode="outlined"
                    />
                </Grid>
            </Grid>
            <Box my={2}>
                <InputSearch
                    onSearch={onSearch}
                    searchText={searchKey}
                />
            </Box>
            <AppTable
                onRequestSort={()=>{}}
                order={queries.asc_sort === true ? "asc" : "desc"}
                orderBy={queries.sort_field}
                rowCount={data.length}
                headCells={headCells}
                // numSelected={countSelectInPage()}
                // onSelectAllClick={_handleSelectAll}
            >
                <TableBody>
                    {loading && (<TableRow>
                        <TableCell colSpan={7} padding="none">
                            <LinearProgress />
                        </TableCell>
                    </TableRow>)}
                    {data.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell>{row.fileName}</TableCell>
                            <TableCell>
                                { moment.utc(row.createdDate).local().format('DD/MM/yyyy HH:mm:ss').toString() }
                            </TableCell>
                            <TableCell>
                                { row.completionDate && row.completionDate !== '' && moment.utc(row.completionDate).local().format('DD/MM/yyyy HH:mm:ss').toString() }
                            </TableCell>
                            <TableCell>{ renderStatus(row) }</TableCell>
                            <TableCell>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left'}} className="text-center">
                                    {
                                        row.errorNumber && row.errorNumber !== 0
                                        ? <span className='pointer nowrap text-info' onClick={() => dispatch(downloadWorkerFileLogs({ id: row.id, fileName: row.errorFileName }))}>
                                            <i className='fa fa-file-alt' /> {t("label.downloadLogs")}
                                        </span>
                                        : null
                                    }
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}

                    {emptyRows > 0 && (
                        <TableRow style={{ height: 53 }}>
                            <TableCell colSpan={headCells.length} className="text-center">
                                {t("label.no_data")}
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            colSpan={headCells.length}
                            count={totalElements}
                            rowsPerPage={queries.size}
                            page={queries.page - 1}
                            SelectProps={{
                                inputProps: { "aria-label": "rows per page" },
                                native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                            labelRowsPerPage={`${t("label.rows_per_page")}:`}
                            labelDisplayedRows={({ from, to, count }) =>
                                t("label.from_to", {
                                    from,
                                    to,
                                    count:
                                        count !== -1 ? count : `${t("text.more_than")} ${to}`,
                                })
                            }
                        />
                    </TableRow>
                </TableFooter>
            </AppTable>
            <AppConfirmDialog
                minWidth={'400px'}
                open={showConfirmImportModal}
                onConfirm={() => _onUploadCsvFile(true)}
                onClose={() => setShowConfirmImportModal(false)}
                onCancel={() => _onUploadCsvFile(false)}
                cancelLabel={t('button.no')}
                title={t('title.confirmOverrideStaffs')}
                content={t('text.confirmOverrideStaffs')}
            />

            <ImportWorkerRulesModal
                open={showRulesModal}
                onClose={() => setShowRulesModal(false)}
            />
        </div>
    );
};

export default TableImportWorker;
